module.exports = __webpack_public_path__ + "static/jc04657-preparation-storage-disposal-8c4a738c836ef5f6e7bf306cf9a1ccda.png";